export enum H2sItemType {
  TOTAL = 'Total',
}
